import * as Request from '../Request';
const Fx = {
  // 新增
  save: (data) => {
    return Request.post('/fx/accident/type/save', data)
  },
  // 编辑
  update: (data) => {
    return Request.put('/fx/accident/type/update', data)
  },
  // 删除
  del: (data) => {
    return Request.del('/fx/accident/type/delete', data)
  },
  // 分页列表
  list: (data) => {
    return Request.post('/fx/accident/type/page/list', data)
  },
  // 事故类型列表
  type: (data) => {
    return Request.get('/fx/accident/type/list', data)
  },
  // 启用
  updateState: (data) => {
    return Request.put('/fx/accident/type/updateState', data)
  },
  // 事故类型列表
  typeAll: (data) => {
    return Request.get('/fx/accident/type/all', data)
  }
}
export default Fx
